<template>
  <article v-if="notices">
    <div
      v-for="notice in notices"
      class="notice alert"
      id="noticeAlert"
      v-html="notice"
      :key="notice"
    ></div>
  </article>
</template>
<script>
export default {
  components: {},
  props: {
    text: {
      required: true,
    },
  },

  computed: {
    notices() {
      return this.$store.getters.errorReportDescriptionIncludeKeywords(
        this.text
      );
    },
  },

  created() {
    //this.$emit("update:confirm", value);
  },
};
</script>
